import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import reduxApp from './reducers/reducers';
import * as serviceWorker from './serviceWorker';
import App from './App';
import './index.scss';
import './i18n';
import { createBrowserHistory } from 'history';

// Convert S3 route redirects (See S3 static website hosting cfg (404 and 403 are currently configurred))
const history = createBrowserHistory();
const path = (/#!(\/.*)$/.exec(window.location.hash) || [])[1];
if (path) {
	history.replace(path);
}

//
const store = createStore(reduxApp, applyMiddleware(thunkMiddleware));

//
ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>,
	document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
